import { render, staticRenderFns } from "./ViewDefaultSidebar.vue?vue&type=template&id=7e45bbda&scoped=true&"
import script from "./ViewDefaultSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewDefaultSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewDefaultSidebar.vue?vue&type=style&index=0&id=7e45bbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45bbda",
  null
  
)

export default component.exports